// Lato, self-hosted (served from our own bucket/CloudFront, no Google Fonts round trip)
require("@fontsource/lato/300.css");
require("@fontsource/lato/400.css");
require("@fontsource/lato/700.css");
require("@fontsource/lato/900.css");
require("./src/styles/global.css");

/**
 * Gatsby Browser APIs
 * 
 * This file is used to customize Gatsby's browser-side behavior.
 * Specifically, we handle scroll restoration and route change behaviors.
 */

/**
 * Handle scroll restoration manually to ensure we always start at the top
 * when navigating to a new page, especially from footer links.
 */
exports.onRouteUpdate = ({ location, prevLocation }) => {
    // If it's a new page (not just a hash change or the same page)
    if (!prevLocation || location.pathname !== prevLocation.pathname) {
        window.scrollTo(0, 0);
    }
    window.gtag?.('event', 'page_view', {
    page_path: location.pathname,
    page_location: window.location.href,
    page_title: document.title,
  });
};

/**
 * Force scroll to top on every route update
 * This is a more aggressive approach if Gatsby's default behavior is inconsistent
 */
exports.shouldUpdateScroll = ({
    routerProps: { location },
    getSavedScrollPosition
}) => {
    // Always scroll to top unless it's a "back" or "forward" browser action
    // where we might want to preserve the previous position
    const savedPosition = getSavedScrollPosition(location);
    
    if (savedPosition) {
        window.scrollTo(...savedPosition);
    } else {
        window.scrollTo(0, 0);
    }
    
    return false; // Prevent Gatsby from handling scroll
};
